import React from 'react';
import { Link } from 'gatsby';
import Icon from 'icon';
import Img from 'img';
import Headline from 'headline';
import s from './influencer-card.module.scss';

function InfluencerCard({ className, influencer, ...props }) {
  const { firstName, lastName, username, featuredImage, country } = influencer;
  return (
    <a className={`${s.inflWrapper} ${className || ''}`} href={`/influencers/${username.replace('@', '')}`}>
      <div className={s.imgWrapper}>
        <Img
          effect
          className={s.featuredImg}
          src={featuredImage || ''}
          alt={featuredImage?.id}
        />
      </div>
      <div className={s.textWrapper}>
        <Headline className={s.fullName}>
          {`${firstName && firstName.replace(firstName[0], firstName[0].toUpperCase())} ${lastName && lastName.replace(lastName[0], lastName[0].toUpperCase())}`}
        </Headline>
        {username && (
          <div className={`${s.flex} ${s.row} ${s.margin}`}>
            <Icon className={s.icon} icon="link-chain" />
            <a
              className={s.text}
              target="_blank"
              rel="noopener noreferrer"
              href={`https://www.instagram.com/${username}`}
              dangerouslySetInnerHTML={{ __html: `@${username}` }}
            />
          </div>
        )}
        {country?.name && (
          <div className={`${s.flex} ${s.row}`}>
            <Icon className={s.icon} icon="location-pin" />
            <p
              className={s.text}
              dangerouslySetInnerHTML={{ __html: country?.name }}
            />
          </div>
        )}
      </div>
    </a>
  );
}

export default React.memo(InfluencerCard);
